var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeGray = function SvgHomeGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#000",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.02 16 29.52 6a8.44 8.44 0 0 0-11 0L7 16a8.78 8.78 0 0 0-3 6.66V39.4A4.6 4.6 0 0 0 8.54 44h6.8A4.58 4.58 0 0 0 20 39.4v-8.64a4.26 4.26 0 0 1 3.4-4.24 4 4 0 0 1 4.76 4v8.88a4.58 4.58 0 0 0 4.5 4.6h6.8A4.6 4.6 0 0 0 44 39.4V22.64A8.82 8.82 0 0 0 41.02 16"
  })));
};
export default SvgHomeGray;